<template>
    <div>
        <el-radio-group v-model="row.isEnabled" @input="handleChange">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
    </div>
</template>

<script>
export default {
    props: {
        row: {
            type: Number
        }
    },
    methods: {
        handleChange(val) {
            let title = val == 1 ? '禁用' : '启用'
            this.$confirm('确定要' + title + this.row.leaveMarkName + '吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'PUT',
                    data: this.row,
                    url: '/xsgl/schoolLeaveMarkSetting/update'
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message({ message: res.message, type: 'success' })
                        this.$emit('refreshListData')
                    }
                })
            }).catch(() => {
                this.row.isEnabled = val == 1 ? 0 : 1
            })
        }
        // this.$http({
        //   method: 'POST',
        //   url: '/xsgl/schoolLeaveMarkSetting/listdata'
        //   }).then(res => {
        //   if (res.code === 'success') {
        //     let _list = res.body.pageInfo.list;
        //     this.allBtnList = res.body.pageInfo.list;
        //     let list = [];
        //     _list.forEach(v=>{
        //       if(v.isEnabled==0){
        //         list.push(v)
        //       }
        //     })
        //     this.btnList = list
        //     }
        //   })
    }
}

</script>

<style>
</style>
